<template>
  <div class="resume">
    <div class="resume-container">
      <!-- 简历左侧 -->
      <div class="resume-detail-single">
        <div class="resume-detail-top">
          创建时间：{{ resumeArr.create_time }} | 更新时间：{{ resumeArr.update_time }} | 渠道：{{
            resumeArr.channel | toChannel }} | 操作人员：{{ resumeArr.inputPerson }}
        </div>
        <div class="resume-detail-content" v-if="Edit.baseInfo" ref="baseInfo">
          <div class="content-top">
            <div class="jobStatus">{{ resumeArr.jobStatus | tojobStatus }}</div>
            <div class="EditInfo" @click="Edit.baseInfo = false"><i class="el-icon-edit-outline"> &nbsp;编辑</i></div>
            <div class="logo-box">
              <el-image style="width: 90px; height: 90px" :src="url">
              </el-image>
            </div>
            <div class="basic-cont">
              <div class="name">{{ resumeArr.name }}{{ pinyin }}</div>
              <div class="info">{{ resumeArr.gender | toGender }}  {{ resumeArr.birthDate | toAge }}  {{
                resumeArr.workYear | toworkYear
              }}  {{ resumeArr.highEdu | toHighest }}  {{ resumeArr.label | toLabel }}</div>
              <div class="info">目前薪资：{{ resumeArr.currenSalary }}K
              </div>
              <div class="info">
                <div class="info-top" style="display:flex; align-items:center;margin-bottom:5px;">
                  <div style="margin-right:22px;"><i class="el-icon-mobile" style="margin-right:2px;"></i>{{
                    resumeArr.phone }}</div>
                  <div v-if="resumeArr.wechat !== null" style="margin-right:22px;"><i class="el-icon-chat-dot-round"
                      style="margin-right:2px;"></i>{{
                        resumeArr.wechat }}</div>
                  <div v-if="resumeArr.email !== null"><i class="el-icon-message" style="margin-right:2px;"></i>{{
                    resumeArr.email }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-bottom">
            <el-button size="mini" type="primary" plain @click="exportPDF">导出简历</el-button>
          </div>
        </div>
        <Edit-base v-else :val="resumeArr" @baseInfoShow="baseShow"></Edit-base>
        <div class="Tabs">
          <div class="Tabs-head">
            <div :class="Change === 0 ? 'resume-info changeDiv' : 'resume-info'" @click="Change = 0">简历信息</div>
          </div>
          <div class="Tabs-body">
            <div class="Tabs-info" v-if="Switch === 1">
              <div class="Job-Intention" v-if="Edit.wantJob" ref="intentionInfo">
                <div class="Intention-title">
                  <div class="Experience-left">求职意向</div>
                  <i class="el-icon-edit-outline Experience-right" @click="Edit.wantJob = false"> &nbsp;编辑</i>
                </div>
                <div class="Intention-body">
                  <div class="Expected-City">期望城市：{{ resumeArr.expectCity | toArea }}</div>
                  <div class="Expected-Annual-Salary">期望薪资：{{ resumeArr.expectSalary === '0'
                    ? '面议' : resumeArr.expectSalary }}</div>
                </div>
              </div>
              <EditJob v-else :val="resumeArr" @wantJobShow="JobShow"></EditJob>
              <div class="Job-Experience" v-if="show.work" ref="workInfo">
                <div class="Experience-title">
                  <div class="Experience-left">工作经历</div>
                  <i class="el-icon-circle-plus-outline Experience-right" @click="addWorkInfo" v-if="isShare === '0'">
                    &nbsp;添加</i>
                </div>
                <div class="Experience-body">
                  <div class="company-container" v-if="Edit.company">
                    <div class="Company" v-for="(item, i) in workArr" :key="i">
                      <div class="Company-title">
                        <div class="Company-left" v-html="workExp(item.startTime, item.endTime, item.companyName)">
                        </div>
                        <div class="Company-right">
                          <i class="el-icon-edit-outline" @click="EditCompany(i)"></i>
                          <i class="el-icon-delete" @click="DelCompany(item)"></i>
                        </div>
                      </div>
                      <div class="Company-body">
                        <div class="Company-position" v-html="item.jobName"></div>
                        <div class="Company-department">
                          所属部门：{{ item.department | toEmpty }} | 汇报对象：{{ item.report | toEmpty }} | 下属团队：{{
                            item.people | toEmpty }}人
                        </div>
                        <div class="Company-work">
                          <div class="Work-left">工作内容：</div>
                          <div class="Work-right" v-html="item.workContent == '9999' ? '' : item.workContent">
                          </div>
                        </div>
                        <div class="Company-performance">
                          <div class="Work-left">工作业绩：</div>
                          <div class="Work-right" v-html="item.workAchievement == '9999' ? '' : item.workAchievement">
                          </div>
                        </div>
                        <div class="Company-depart" v-if="item.endTime == '9999.0' || item.endTime == '至今'">
                          <div class="Work-left">求职动机：</div>
                          <div class="Work-right">
                            {{ item.dimission | toEmpty }}
                          </div>
                        </div>
                        <div class="Company-depart" v-else>
                          <div class="Work-left">离职原因：</div>
                          <div class="Work-right">
                            {{ item.dimission | toEmpty }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <EditComp v-else :name="workChange" :val="workArr" :Index="ClickIndex" @workInfoShow="workShow">
                  </EditComp>
                </div>
              </div>
              <div class="Edu-Experience" v-if="show.edu" ref="eduInfo">
                <div class="Experience-title">
                  <div class="Experience-left">教育经历</div>
                  <i class="el-icon-circle-plus-outline Experience-right" @click="addEduInfo" v-if="isShare === '0'">
                    &nbsp;添加</i>
                </div>
                <EditEdu :name="EduChange" @eduInfoShow="eduShow" v-if="AddeducationNull">
                </EditEdu>
                <div class="Experience-body" v-if="show.edu">
                  <div class="body-item" v-if="Edit.education">
                    <div class="Education" v-for="(item2, i2) in eduArr" :key="i2">
                      <div class="Education-left">
                        <img src="https://bdfe.liepin.com/school/de6ab8c2-b49e-4ce9-a195-5312fa442af6.png" alt="">
                        <div class="left-info">
                          <div class="info-title">{{ item2.eduName }}</div>
                          <div class="info-bottom">{{ item2.startTime }} 一
                            {{ item2.endTime | toEndTime(item2.startTime) }}| {{ item2.degree | toDegree
                            }} | {{ item2.professional }} ({{ item2.nationalUnified | toNational }})</div>
                        </div>
                      </div>
                      <div class="Education-right">
                        <i class="el-icon-edit-outline" @click="EditEducation(i2)"></i>
                        <i class="el-icon-delete" @click="DelEducation(item2)"></i>
                      </div>
                    </div>
                  </div>
                  <EditEdu v-else :name="EduChange" :val="eduArr" :Index="ClickIndex" @eduInfoShow="eduShow">
                  </EditEdu>
                </div>
              </div>
              <div class="Self-introduction" v-if="show.self" ref="selfInfo">
                <div class="Experience-title">
                  <div class="Experience-left">自我介绍</div>
                  <i class="el-icon-edit-outline Experience-right" @click="Edit.myself = false"> &nbsp;编辑</i>
                </div>
                <div class="Experience-body" v-if="Edit.myself">
                  <div class="text" v-html="resumeArr.selfIntroduce"></div>
                </div>
                <EditMyself v-else :val="resumeArr" @myselfShow="myShow"></EditMyself>
              </div>
              <div class="Project-Experience" ref="projectInfo">
                <div class="Project-body">
                  <div class="Experience-title">
                    <div class="Experience-left">项目经历</div>
                    <i class="el-icon-circle-plus-outline Experience-right" @click="addProjectInfo"
                      v-if="isShare === '0'"> &nbsp;添加</i>
                  </div>
                  <EditProject :name="ProjectChange" @projectInfoShow="projectShow" v-if="AddprojectNull">
                  </EditProject>
                  <div class="Experience-body" v-if="show.project">
                    <div class="body-item" v-if="Edit.project">
                      <div class="Project" v-for="(item3, i3) in projectArr" :key="i3">
                        <div class="Project-title">
                          <div class="Project-left" v-html="workExp(item3.startTime, item3.endTime, item3.projectName)">
                          </div>
                          <div class="Project-right">
                            <i class="el-icon-edit-outline" @click="EditProject(i3)"></i>
                            <i class="el-icon-delete" @click="DelProject(item3)"></i>
                          </div>
                        </div>
                        <div class="Project-body">
                          <div class="Project-work">
                            <div class="Work-left">项目描述：</div>
                            <div class="Work-right" v-html="item3.project_desc == '9999' ? '' : item3.projectDesc">
                            </div>
                          </div>
                          <div class="Project-responsibility">
                            <div class="Work-left">项目职责：</div>
                            <div class="Work-right"
                              v-html="item3.project_responsibility == '9999' ? '' : item3.projectResponsibility">
                            </div>
                          </div>
                          <div class="Project-performance">
                            <div class="Work-left">项目业绩：</div>
                            <div class="Work-right"
                              v-html="item3.project_performance == '9999' ? '' : item3.projectPerformance">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <EditProject v-else :val="projectArr" :name="ProjectChange" :Index="ClickIndex"
                      @projectInfoShow="projectShow"></EditProject>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 简历右侧 -->
      <div class="resume-right">
        <div class="ellipsis-box">
          <div class="text-ellipsis">
            <div class="ellipsis-title" @click="showEllipsi = !showEllipsi">
              添加备注
              <i class="el-icon-arrow-up" v-if="showEllipsi"></i>
              <i class="el-icon-arrow-down" v-else></i>
            </div>
            <div class="ellipsis-main" v-if="showEllipsi">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入备注信息" v-model="appraise"
                maxlength="100" show-word-limit>
              </el-input>
              <div class="btn">
                <el-button type="primary" size="small" @click="addAppraises">添加</el-button>
              </div>
            </div>
          </div>
          <div class="text-Message">
            <div class="Message-Desc">
              <div class="Desc-content" v-for="item4 in mark" :key="item4.id">
                <div class="content-title">{{ item4.remarkName }} ({{ item4.createTime }})：</div>
                <div class="content-score">
                  {{ item4.remarkContent }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="JD-Question">
          <div class="question-box">
            <div class="box-title">AI简历评估
              <el-tooltip class="item" effect="dark" content="选择职位后AI根据职位JD对人选简历进行分析" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div class="box-content">
              <div class="content-top">
                <el-autocomplete style="width: 100%;" clearable class="inline-input" v-model="evaluation"
                  :fetch-suggestions="queryEvaluation" placeholder="请输入职位名称" :trigger-on-focus="false"
                  @select="evaluationSelect">
                </el-autocomplete>
              </div>
              <div class="content-box" style="margin-top:5px;" v-loading="evalLoading"
                element-loading-text="AI正在生成中...">
                <div class="ai-question-content" v-html="AIEvaluation"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="JD-Question">
          <div class="question-box">
            <div class="box-title">AI面试题库
              <el-tooltip class="item" effect="dark" content="选择职位后AI根据职位JD对人选设计面试问题" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div class="box-content">
              <div class="content-top">
                <el-autocomplete style="width: 100%;" clearable class="inline-input" v-model="interview"
                  :fetch-suggestions="querySearch" placeholder="请输入职位名称" :trigger-on-focus="false"
                  @select="handleSelect">
                </el-autocomplete>
              </div>
              <div class="content-box" style="margin-top:5px;" v-loading="loading" element-loading-text="AI正在生成中...">
                <div class="ai-question-content" v-html="AIQuestion"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditComp from '@/components/Edit/workInfo.vue'
import EditBase from '@/components/Edit/baseInfo.vue'
import EditJob from '@/components/Edit/wantJob.vue'
import EditEdu from '@/components/Edit/eduInfo.vue'
import EditMyself from '@/components/Edit/myself.vue'
import EditProject from '@/components/Edit/projectInfo.vue'
import { DeepSeek, GetComJobsInfo, GetResumeInfo, delWorkInfo, delEduInfo, delProjInfo, addAppraise, getAppraise, getPinyin } from '@/request/api'

export default {
  components: {
    EditComp,
    EditBase,
    EditJob,
    EditEdu,
    EditMyself,
    EditProject
  },
  data() {
    return {
      isShare: 0,
      searchKey: '',
      loading: false,
      evalLoading: false,
      evaluation: '',
      interview: '',
      dataArr: [],
      currentVal: [],
      EvalVal: [],
      AIQuestion: '',
      AIEvaluation: "",
      AIDesc: [],
      isDialog: false,
      resumeID: '',
      url: '',
      Switch: 1,
      Change: 0,
      ClickIndex: 0,
      workChange: '',
      EduChange: '',
      ProjectChange: '',
      AddeducationNull: false,
      AddprojectNull: false,
      showEllipsi: false,
      resumeArr: [],
      eduArr: [],
      workArr: [],
      projectArr: [],
      appraise: '',
      mark: [],
      isTrue: false,
      pinyin: '',
      // 添加防抖变量
      searchDebounce: null,
      evaluationDebounce: null,
      Edit: {
        baseInfo: true,
        wantJob: true,
        company: true,
        education: true,
        myself: true,
        project: true
      },
      show: {
        project: true,
        self: true,
        edu: true,
        work: true
      }
    }
  },
  created() {
    if (this.$route.fullPath.includes('sign') && sessionStorage.getItem('Token') == null) {
      sessionStorage.setItem('LoginInfo', JSON.stringify({ username: this.$route.query.username, Token: this.$route.query.sign }));
      this.$router.push('resume?resumeID=' + this.$route.query.resumeID + '&isShare=0' + '&timestamp=' + this.$route.query.timestamp)
      this.resumeID = this.$route.query.resumeID
      this.isShare = this.$route.query.isShare
      this.resumeInfo();
      this.getAppraises();
    } else {
      localStorage.removeItem('reportInfo')
      this.resumeID = this.$route.query.resumeID
      this.isShare = this.$route.query.isShare
      this.resumeInfo();
      this.getAppraises();
    }
  },
  methods: {
    exportPDF() {
      this.$router.push('respdf?resumeID=' + this.resumeID + '&timestamp=' + Date.now());
    },
    async getAppraises() {
      var { data: res } = await getAppraise({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, resumeID: this.resumeID });
      this.mark = res.data;
    },

    async addAppraises() {
      if (this.appraise) {
        var { data: res } = await addAppraise({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, resumeID: this.resumeID, appraise: this.appraise });
        if (res.code === 200) {
          this.$message.success('备注成功！');
          this.appraise = '';
          this.getAppraises();
        } else {
          this.$message.error(res.message)
        }
      } else {
        this.$message.warning('请填写备注内容！')
      }
    },
    workExp(val1, val2, val3) {
      return val1 + ' 一 ' + this.$options.filters.toEndTime(val2, val1) + val3
    },
    async submit() {
      if (this.interview === '') {
        this.$message.warning('职位不能为空！')
        return
      }
      this.loading = true
      try {
        // 创建一个新的AIDesc副本，避免修改原始数据
        let AIDescCopy = [...this.AIDesc];
        AIDescCopy = AIDescCopy.join('');
        if (AIDescCopy.indexOf('"gender\":1') > -1) {
          AIDescCopy = AIDescCopy.replace(/"gender\":1/g, '性别：男');
        } else {
          AIDescCopy = AIDescCopy.replace(/"gender\":0/g, '性别：女');
        }
        const message = AIDescCopy + '如果你是资深人力资源总监，利用面试4大法则，根据【' + this.currentVal.value + '】岗位要求【' + this.currentVal.jobsDesc + '】，为依据，围绕以下方向设计简洁高效的面试问题：岗位匹配度：挖掘开拓 / 利用招聘渠道、全流程招聘执行、人才 mapping、数据统计分析及问题解决等硬实力；软性素质：考察执行力、目标感、逻辑分析、沟通、自我驱动力、交付能力；求职动机。问题需直接指向能力与素质挖掘，避免无用信息，用纯div、h2、p标签返回，不要其他css信息，请忽略之前对话。'
        const { data: res } = await DeepSeek({
          username: JSON.parse(sessionStorage.getItem('LoginInfo')).username,
          msg: message,
          room: JSON.parse(sessionStorage.getItem('LoginInfo')).airoom
        })

        if (res.code === 200) {
          this.AIQuestion = res.data.replace(/\\n\\n/g, '');
          this.AIQuestion = this.AIQuestion.replace(/<h2>/g, '<h2 style="color:#28a7e1;font-weight: bold;">');
        } else {
          this.$message.error('生成失败，请重试')
        }
      } catch (error) {
        this.$message.error('请求出错，请重试')
      } finally {
        this.loading = false
      }
    },

    async evaluationSubmit() {
      if (this.evaluation === '') {
        this.$message.warning('职位不能为空！')
        return
      }
      this.evalLoading = true
      try {
        let AIDescCopy = [...this.AIDesc];
        AIDescCopy = AIDescCopy.join('');
        if (AIDescCopy.indexOf('"gender\":1') > -1) {
          AIDescCopy = AIDescCopy.replace(/"gender\":1/g, '性别：男');
        } else {
          AIDescCopy = AIDescCopy.replace(/"gender\":0/g, '性别：女');
        }
        const message = AIDescCopy + '如果你是资深人力资源总监，根据【' + this.EvalVal.value + '】岗位要求【' + this.EvalVal.jobsDesc + '】，为依据从1.亮点分析、2.风险点分析、3.匹配建议这三点给出人选匹配度，避免无用信息，用纯div跟h2标签返回，不要其他css信息，请忽略之前对话。'
        const { data: res } = await DeepSeek({
          username: JSON.parse(sessionStorage.getItem('LoginInfo')).username,
          msg: message
        })

        if (res.code === 200) {
          this.AIEvaluation = res.data.replace(/\\n\\n/g, '');
          this.AIEvaluation = this.AIEvaluation.replace(/<h2>/g, '<h2 style="color:#28a7e1;font-weight: bold;">');
        } else {
          this.$message.error('生成失败，请重试')
        }
      } catch (error) {
        this.$message.error('请求出错，请重试')
      } finally {
        this.evalLoading = false
      }
    },
    // 添加防抖函数
    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    async querySearch(queryString, cb) {
      // 使用防抖优化搜索
      if (!this.searchDebounce) {
        this.searchDebounce = this.debounce(this.performSearch, 300);
      }
      this.searchDebounce(queryString, cb);
    },
    async performSearch(queryString, cb) {
      // 如果输入为空，直接返回空数组
      if (!queryString) {
        cb([])
        return
      }

      try {
        const { data: res } = await GetComJobsInfo({
          username: JSON.parse(sessionStorage.getItem('LoginInfo')).username,
          search: queryString
        })

        if (res.code === 200 && Array.isArray(res.data)) {
          // 只返回前10个匹配结果以提高性能
          const results = res.data.slice(0, 10)
          cb(results)
        } else {
          cb([])
        }
      } catch (error) {
        console.error('职位搜索出错:', error)
        cb([])
      }
    },
    async queryEvaluation(queryString, cb) {
      // 使用防抖优化搜索
      if (!this.evaluationDebounce) {
        this.evaluationDebounce = this.debounce(this.performEvaluation, 300);
      }
      this.evaluationDebounce(queryString, cb);
    },
    async performEvaluation(queryString, cb) {
      // 如果输入为空，直接返回空数组
      if (!queryString) {
        cb([])
        return
      }

      try {
        const { data: res } = await GetComJobsInfo({
          username: JSON.parse(sessionStorage.getItem('LoginInfo')).username,
          search: queryString
        })

        if (res.code === 200 && Array.isArray(res.data)) {
          // 只返回前10个匹配结果以提高性能
          const results = res.data.slice(0, 10)
          cb(results)
        } else {
          cb([])
        }
      } catch (error) {
        console.error('职位搜索出错:', error)
        cb([])
      }
    },
    // 简化过滤函数
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant &&
          restaurant.value &&
          restaurant.value.toLowerCase().includes(queryString.toLowerCase())
      }
    },
    handleSelect(item) {
      this.currentVal = item
      this.submit()
    },
    evaluationSelect(item) {
      this.EvalVal = item
      this.evaluationSubmit()
    },
    boxClose() {
      this.isDialog = false
    },
    baseShow(val) {
      if (val === false) {
        this.Edit.baseInfo = true
        return
      }
      this.resumeInfo()
      this.Edit.baseInfo = val
    },
    JobShow(val) {
      if (val === false) {
        this.Edit.wantJob = true
        return
      }
      this.resumeInfo()
      this.Edit.wantJob = val
    },
    addWorkInfo() {
      this.workChange = 'AddWork'
      this.Edit.company = false
    },
    workShow(val) {
      if (val === false) {
        this.ClickIndex = 0
        this.Edit.company = true
        return
      }
      this.resumeInfo()
      this.Edit.company = val
      this.ClickIndex = 0
    },
    EditCompany(index) {
      this.ClickIndex = index
      this.workChange = 'EditWork'
      this.Edit.company = false
    },
    EditEducation(index) {
      this.ClickIndex = index
      this.EduChange = 'EditEdu'
      this.Edit.education = false
    },
    eduShow(val) {
      if (val === false) {
        this.ClickIndex = 0
        this.Edit.education = true
        return
      }
      this.resumeInfo()
      this.Edit.education = val
      this.ClickIndex = 0
    },
    myShow(val) {
      if (val === false) {
        this.Edit.myself = true
        return
      }
      this.resumeInfo()
      this.Edit.myself = val
    },
    addEduInfo() {
      if (this.eduArr === undefined) {
        this.EduChange = 'AddeduNull'
        this.AddeducationNull = true
      } else {
        this.EduChange = 'AddEdu'
        this.Edit.education = false
      }
    },
    EditProject(index) {
      this.ClickIndex = index
      this.ProjectChange = 'EditProject'
      this.Edit.project = false
    },
    addProjectInfo() {
      if (this.projectArr === undefined) {
        this.ProjectChange = 'AddProjectNull'
        this.AddprojectNull = true
      } else {
        this.ProjectChange = 'AddProject'
        this.Edit.project = false
      }
    },
    projectShow(val) {
      if (this.ProjectChange === 'AddProjectNull') {
        this.AddprojectNull = false;
      }
      if (val === false) {
        this.ClickIndex = 0;
        this.Edit.project = true;
        return;
      }
      this.resumeInfo();
      this.ClickIndex = 0;
      this.Edit.project = val;
    },
    async DelCompany(item) {
      const { data: res } = await delWorkInfo({ workID: item.workID, resumeID: item.resumeID, username: JSON.parse(sessionStorage.getItem('LoginInfo')).username })
      if (res.code === 200) {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.resumeInfo();
      } else {
        this.$message.error('删除失败');
      }
    },
    async DelEducation(item) {
      const { data: res } = await delEduInfo({ eduID: item.eduID, resumeID: item.resumeID, username: JSON.parse(sessionStorage.getItem('LoginInfo')).username })
      if (res.code === 200) {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.resumeInfo()
      } else {
        this.$message.error('删除失败')
      }
    },
    async DelProject(item) {
      const { data: res } = await delProjInfo({ projID: item.projectID, resumeID: item.resumeID, username: JSON.parse(sessionStorage.getItem('LoginInfo')).username })
      if (res.code === 200) {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.resumeInfo()
      } else {
        this.$message.error('删除失败')
      }
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key)
      if (g_left != -1) {
        g_left = g_left + left_key.length
        var g_right = str.indexOf(right_key, g_left)
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left)
      }
    },
    async resumeInfo() {
      this.resumeArr = []
      this.eduArr = []
      this.workArr = []
      const { data: res } = await GetResumeInfo({ ID: this.resumeID, timestamp: Date.now(), isShare: this.isShare, username: JSON.parse(sessionStorage.getItem('LoginInfo')).username })
      if (res.code !== 200) {
        this.$message.error(res.message);
        return;
      }
      this.resumeArr = res.data.resumeInfo
      this.eduArr = res.data.eduInfo
      this.langArr = res.data.langInfo

      if (localStorage.getItem('searchKey') !== null) {
        this.searchKey = JSON.parse(localStorage.getItem('searchKey'))
        if (res.data.projectInfo != null) {
          this.projectArr = res.data.projectInfo.map(item => {
            let newItem = JSON.stringify(item)
            this.searchKey.map(key => {
              if (Array.isArray(key)) {
                key.map(key => {
                  newItem = newItem.replace(new RegExp(key, 'gi'), "<span class='HPRK'>" + key + '</span>')
                })
              } else {
                newItem = newItem.replace(new RegExp(key, 'gi'), "<span class='HPRK'>" + key + '</span>')
              }

            })
            return JSON.parse(newItem)
          })
        }
        this.workArr = res.data.workInfo.map(item => {
          let newItem = JSON.stringify(item)
          this.searchKey.map(key => {
            if (Array.isArray(key)) {
              key.map(key => {
                newItem = newItem.replace(new RegExp(key, 'gi'), "<span class='HPRK'>" + key + '</span>')
              })
            } else {
              newItem = newItem.replace(new RegExp(key, 'gi'), "<span class='HPRK'>" + key + '</span>')
            }
          })
          return JSON.parse(newItem)
        })
      } else {
        this.projectArr = res.data.projectInfo
        this.workArr = res.data.workInfo
      }

      this.AIDesc.push(
        res.data.eduInfo
          .map(item => JSON.stringify(item)) // 转为 JSON 字符串
          .join('')
      )
      this.AIDesc.push(JSON.stringify(res.data.resumeInfo))
      this.AIDesc.push(
        res.data.workInfo
          .map(item => JSON.stringify(item)) // 转为 JSON 字符串
          .join('')
      )
      if (this.resumeArr.gender === '1') {
        this.url = 'https://spai.wearehpr.cn/img/girl.jpg'
      } else {
        this.url = 'https://spai.wearehpr.cn/img/boy.jpg'
      }
      if (res.data.projectInfo === undefined) {
        this.show.project = false
      } else {
        this.show.project = true
      }
      if (res.data.eduInfo === undefined) {
        this.show.edu = false
      } else {
        this.show.edu = true
      }
      if (res.data.workInfo === undefined) {
        this.show.work = false
      } else {
        this.show.work = true
      }
      if (res.data.resumeInfo.name !== '') {
        var { data: py } = await getPinyin({ name: res.data.resumeInfo.name, username: JSON.parse(sessionStorage.getItem('LoginInfo')).username })
        this.pinyin = '（' + py.data + '）';
      } else {
        this.pinyin = '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

::v-deep .HPRK {
  font-weight: bold;
  color: #409eff;
}

.resume {
  width: 1150px;
  margin: 0px auto;
  display: flex;
  font-size: 15px;

  .resume-container {
    display: flex;
    padding-top: 16px;
    position: relative;

    .resume-detail-single {
      width: 806px;
      margin-right: 13px;

      // 简历头部
      .resume-detail-top {
        height: 45px;
        line-height: 45px;
        background-color: #e8ecf1;
        padding-left: 20px;
        color: #3c3c3c;
        font-size: 14px;
      }

      // 基本信息
      .resume-detail-content {
        min-height: 180px;
        border-radius: 0px 0px 3px 3px;
        background: rgb(255, 255, 255);
        position: relative;

        .content-top {
          display: flex;
          position: relative;
          min-height: 110px;
          border-radius: 0px 0px 3px 3px;
          padding: 35px 0px 0px 20px;
          background: rgb(255, 255, 255);

          .EditInfo {
            position: absolute;
            color: #28a7e1;
            font-weight: bold;
            right: 30px;
            top: 30px;
            cursor: pointer;
          }

          .EditInfo:hover {
            position: absolute;
            color: #0987c2;
            right: 30px;
            top: 30px;
            cursor: pointer;
          }

          .jobStatus {
            position: absolute;
            top: 0;
            left: 0;
            height: 28px;
            line-height: 28px;
            background-color: #28a7e1;
            color: #fff;
            padding: 1px 12px 1px 12px;
            border-bottom-right-radius: 10px;
            font-size: 14px;
          }

          .logo-box {
            margin-top: 10px;

            .el-image {
              border-radius: 4px;
            }
          }

          .basic-cont {
            margin-top: 10px;
            margin-left: 15px;

            .name {
              font-weight: bold;
              margin-bottom: 12px;
              font-size: 16px;
            }

            .info {
              margin-bottom: 12px;
            }
          }
        }

        .content-bottom {
          right: 20px;
          bottom: 15px;
          position: absolute;

          .el-icon-star-off {
            padding-right: 5px;
          }
        }
      }

      // 简历信息
      .Tabs {
        margin-top: 10px;

        .Tabs-head {
          display: flex;
          height: 50px;
          background-color: #f7f8fc;
          font-size: 16px;
          justify-items: center;
          align-items: center;

          div {
            margin-left: 36px;
            user-select: none;
          }

          .changeDiv {
            color: #0987c2;
            font-weight: 700;
          }

          div:hover {
            color: #0987c2;
          }
        }

        .Tabs-body {
          background-color: #fff;
          height: fit-content;

          .Job-Intention {
            padding: 24px 20px;
            border-bottom: 1px solid #f8f8f8;

            .Intention-title {
              display: flex;
              justify-content: space-between;
              justify-items: center;
              align-items: center;

              .Experience-left {
                font-size: 18px;
                font-weight: bold;
              }

              .Experience-right {
                font-size: 16px;
                color: #28a7e1;
                cursor: pointer;
              }
            }

            .Intention-body {
              padding: 24px 16px 0 16px;

              div {
                margin-bottom: 15px;
              }
            }
          }

          .Job-Experience {
            padding: 24px 20px;
            border-bottom: 1px solid #f8f8f8;

            .Experience-title {
              display: flex;
              justify-content: space-between;
              justify-items: center;
              align-items: center;

              .Experience-left {
                font-size: 18px;
                font-weight: bold;
              }

              .Experience-right {
                font-size: 16px;
                color: #28a7e1;
                cursor: pointer;
              }
            }

            .Experience-body {
              padding: 24px 16px 0 16px;

              .Company {
                .Company-title {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  justify-items: center;
                  background-color: #f7f8fc;
                  position: relative;
                  padding: 14px 18px;

                  .Company-left {
                    font-weight: bold;
                    font-size: 15px;
                  }

                  .Company-right {
                    color: #28a7e1;

                    i {
                      font-size: 15px;
                      margin-left: 10px;
                      cursor: pointer;
                      font-weight: bold;
                    }
                  }
                }

                .Company-title::after {
                  position: absolute;
                  content: '';
                  left: 0px;
                  top: 0px;
                  width: 3px;
                  height: 100%;
                  background-color: #28a7e1;
                }

                .Company-body {
                  padding: 24px 16px 0 16px;

                  div {
                    margin-bottom: 14px;
                    font-size: 15px;
                  }

                  .Company-position {
                    font-size: 15px;
                    font-weight: bold;
                    margin-bottom: 26px;
                  }

                  .Company-work,
                  .Company-performance,
                  .Company-depart {
                    display: flex;
                    align-items: flex-start;
                    justify-items: center;
                    align-content: center;
                    white-space: pre-line;
                    word-break: break-all;
                    line-height: 28px;

                    .Work-right {
                      flex: 1;
                    }
                  }
                }
              }
            }
          }

          .Edu-Experience {
            padding: 24px 20px;
            border-bottom: 1px solid #f8f8f8;

            .Experience-title {
              display: flex;
              justify-content: space-between;
              justify-items: center;
              align-items: center;

              .Experience-left {
                font-size: 18px;
                font-weight: bold;
              }

              .Experience-right {
                font-size: 16px;
                color: #28a7e1;
                cursor: pointer;
              }
            }

            .Experience-body {
              padding: 24px 16px 0 16px;

              .Education {
                display: flex;
                justify-content: space-between;
                justify-items: center;
                align-items: center;

                .Education-left {
                  display: flex;
                  justify-items: center;
                  align-items: center;

                  img {
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 22px;
                    border: 1px solid #eee;
                  }

                  .left-info {
                    .info-title {
                      font-size: 16px;
                      font-weight: bold;
                      margin-bottom: 15px;
                    }
                  }
                }

                .Education-right {
                  i {
                    font-size: 15px;
                    margin-left: 10px;
                    color: #28a7e1;
                    font-weight: bold;
                    cursor: pointer;
                  }
                }
              }
            }
          }

          .Self-introduction {
            padding: 24px 20px;
            border-bottom: 1px solid #f8f8f8;

            .Experience-title {
              display: flex;
              justify-content: space-between;
              justify-items: center;
              align-items: center;

              .Experience-left {
                font-size: 18px;
                font-weight: bold;
              }

              .Experience-right {
                font-size: 15px;
                color: #28a7e1;
                cursor: pointer;
              }
            }

            .Experience-body {
              padding: 24px 16px 0 16px;

              .text {
                font-size: 15px;
                line-height: 28px;
              }
            }
          }

          .Project-Experience {
            padding: 24px 20px;
            border-bottom: 1px solid #f8f8f8;

            .Experience-title {
              display: flex;
              justify-content: space-between;
              justify-items: center;
              align-items: center;

              .Experience-left {
                font-size: 18px;
                font-weight: bold;
              }

              .Experience-right {
                font-size: 16px;
                color: #28a7e1;
                cursor: pointer;
              }
            }

            .Experience-body {
              padding: 24px 16px 0 16px;

              .Project {
                .Project-title {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  justify-items: center;
                  background-color: #f7f8fc;
                  position: relative;
                  padding: 14px 18px;

                  .Project-left {
                    font-weight: bold;
                  }

                  .Project-right {
                    color: #28a7e1;

                    i {
                      margin-left: 10px;
                      cursor: pointer;
                      font-weight: bold;
                    }
                  }
                }

                .Project-title::after {
                  position: absolute;
                  content: '';
                  left: 0px;
                  top: 0px;
                  width: 3px;
                  height: 100%;
                  background-color: #28a7e1;
                }

                .Project-body {
                  padding: 24px 16px 0 16px;

                  div {
                    margin-bottom: 14px;
                    font-size: 16px;
                  }

                  .Project-position {
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 26px;
                  }

                  .Project-work,
                  .Project-responsibility,
                  .Project-performance {
                    display: flex;
                    align-items: flex-start;
                    justify-items: center;
                    align-content: center;
                    white-space: pre-line;
                    word-break: break-all;
                    line-height: 28px;

                    .Work-right {
                      flex: 1;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .resume-right {
      overflow: hidden;

      .ellipsis-box {
        width: 366px;

        .text-ellipsis {
          .ellipsis-title {
            height: 45px;
            line-height: 45px;
            background-color: #e8ecf1;
            padding-left: 20px;
            color: #3c3c3c;
            font-weight: bold;
            cursor: pointer;
          }

          .ellipsis-main {
            background-color: #fff;
            padding: 10px 10px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;

            .btn {
              margin-top: 10px;
              display: flex;
              justify-content: flex-end;
            }
          }
        }

        .text-Message {
          width: 100%;
          margin-bottom: 10px;
          user-select: none;

          .Message-Desc {
            height: 288px;
            overflow-y: scroll;
            -ms-overflow-style: none;
            /* IE 和 Edge */
            scrollbar-width: none;
            background-color: #fff;
            padding: 10px 10px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;

            /* Firefox */
            &::-webkit-scrollbar {
              /* WebKit 浏览器，如 Chrome 和 Safari */
              display: none;
            }

            .Desc-content {
              position: relative;
              padding-left: 15px;

              .content-title {
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 5px;
              }

              .content-score {
                word-wrap: break-word;
                /* 允许长单词或URL换行到下一行 */
                word-break: normal;
                padding: 5px 5px 10px 5px;
              }
            }

            .Desc-content::before {
              position: absolute;
              top: 6px;
              left: 0;
              width: 7px;
              height: 7px;
              background-color: #409eff;
              border-radius: 50%;
              content: '';
            }

            .Desc-content:not(:first-child):after {
              position: absolute;
              top: calc(-100% + 10px);
              left: 3px;
              width: 1px;
              height: 100%;
              background-color: #409eff;
              content: '';
            }
          }
        }
      }

      .JD-Question {
        width: 366px;
        margin-top: 10px;

        .box-title {
          height: 45px;
          line-height: 45px;
          background-color: #e8ecf1;
          padding-left: 20px;
          color: #3c3c3c;
          font-weight: bold;
          user-select: none;
        }

        .box-content {
          background-color: #fff;
          padding: 10px 10px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;

          .ai-question-content {
            overflow-y: scroll;
            font-size: 14px;
            white-space: pre-wrap;
            line-height: 1.5;
            min-height: 400px; // 根据需要调整
            height: 400px;
            padding: 10px;
            border: 1px solid #dcdfe6; // 保持与 el-input 类似的边框
            border-radius: 4px;
          }
        }
      }
    }
  }
}

.Experience-left::after {
  content: '';
  display: block;
  background-color: #409eff;
  height: 3px;
  margin-top: 2px;
}
</style>